import { useRef, useState } from 'react';
import { useTempSocket } from '../../hooks/useTempSocket';
import { Modal, Form, Input, Button, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

export const DEVICE_KEYS = {
  899899: {
    label: 'IEC Q',
    key: 'Q',
  },
  254412: {
    label: 'IEC A',
    key: 'A',
  },
  456217: {
    label: 'IEC B',
    key: 'B',
  },
};

export default function IEC104() {
  const stateRef = useRef({});
  const [state, setState] = useState({});
  const [configs, setConfigs] = useState(null);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [form] = Form.useForm();

  const { configIEC104, requestConfigIEC104 } = useTempSocket([
    {
      event: 'connect',
      cb: () => {
        requestConfigIEC104();
      },
    },
    {
      event: 'iec-104-config-result',
      cb: (payload) => {
        setConfigs(payload);
      },
    },

    {
      event: 'iec104',
      cb: (payload) => {
        if (stateRef.current[payload.user_equipment_id] == null) {
          stateRef.current[payload.user_equipment_id] = {};
        }
        stateRef.current[payload.user_equipment_id][payload.parameter_name] =
          payload.current_value;

        setState({ ...stateRef.current });
      },
    },
  ]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const updatedConfig = {
          ...selectedConfig,
          connection: { ...selectedConfig.connection, ...values },
        };
        updatedConfig.connection.host = values.host;
        updatedConfig.connection.port = values.port;
        updatedConfig.equipments[0].parameters =
          values.equipments[0].parameters;

        const payload = {
          device_code: DEVICE_KEYS[selectedConfig.equipments[0].id].key,
          connection: {
            host: updatedConfig.connection.host,
            port: updatedConfig.connection.port,
          },
          parameters: updatedConfig.equipments[0].parameters,
        };
        alert(payload.device_code);

        configIEC104(payload);
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((errorInfo) => {
        console.error('Validation Failed:', errorInfo);
      });
  };

  const showEditModal = (config) => {
    setSelectedConfig(config);
    form.setFieldsValue({
      host: config.connection.host,
      port: config.connection.port,
      equipments: [config.equipments[0]],
    });
    setIsModalVisible(true);
  };

  return (
    <div>
      <div className="mx-4 my-3">
        <Button
          className="mx-2 bg-white"
          onClick={() => showEditModal(configs.A)}
        >
          Edit A
        </Button>
        <Button
          className="mx-2  bg-white"
          onClick={() => showEditModal(configs.B)}
        >
          Edit B
        </Button>
        <Button
          className="mx-2  bg-white"
          onClick={() => showEditModal(configs.Q)}
        >
          Edit Q
        </Button>
      </div>
      <div className="mx-2 flex">
        {Object.entries(state).map(([key, equipment]) => {
          return (
            <div className="flex-1 rounded-md m-4 p-6 bg-white shadow">
              <div key={key} className="mx-6">
                {(function () {
                  return DEVICE_KEYS[key]?.label || 'Unknown ' + key;
                })()}
              </div>
              {Object.entries(equipment).map(([param, value]) => {
                return (
                  <div
                    key={param}
                    className="flex justify-center items-center text-sm rounded shadow p-2 m-4"
                  >
                    <span className="flex-1">{param}</span>
                    <span className="flex-1">{value}</span>
                  </div>
                );
              })}
            </div>
          );
        })}

        <Modal
          title="Edit IEC104 Config"
          open={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
          }}
          onOk={handleSave}
          width={1000}
        >
          <Form form={form} initialValues={selectedConfig}>
            <div className="flex m-4">
              <Form.Item
                className="mx-2"
                name="host"
                label="Host"
                rules={[{ required: true, message: 'Please input the host!' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="port"
                label="Port"
                rules={[{ required: true, message: 'Please input the port!' }]}
              >
                <Input type="number" />
              </Form.Item>
            </div>
            <Form.List
              name={['equipments', 0, 'parameters']}
              initialValues={selectedConfig}
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Space
                      key={key}
                      style={{ display: 'flex', marginBottom: 8 }}
                      align="baseline"
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'parameter_name']}
                        fieldKey={[fieldKey, 'parameter_name']}
                        style={{
                          width: 500,
                        }}
                        rules={[
                          { required: true, message: 'Missing parameter name' },
                        ]}
                      >
                        <Input placeholder="Parameter Name" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'address']}
                        fieldKey={[fieldKey, 'address']}
                        rules={[{ required: true, message: 'Missing address' }]}
                      >
                        <Input placeholder="Address" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'type']}
                        fieldKey={[fieldKey, 'type']}
                        rules={[{ required: true, message: 'Missing type' }]}
                      >
                        <Input placeholder="Type" />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Add Parameter
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form>
        </Modal>
      </div>
    </div>
  );
}
